import React from 'react';
import { PlayCircle } from 'lucide-react';

const videos = [
  {
    id: 'communities',
    title: 'In Your Communities, Reaching Out',
    description: 'Clianda Florence connecting with families and neighbors across Rochester.',
    src: 'https://customer-assets.emergentagent.com/job_884fa731-48eb-4f1c-909a-794cdb7d5a22/artifacts/k35517oi_in_your_communities_reach_out.MP4'
  },
  {
    id: 'readiness',
    title: 'College and Career Readiness',
    description: 'Preparing our students for success after graduation.',
    src: 'https://customer-assets.emergentagent.com/job_884fa731-48eb-4f1c-909a-794cdb7d5a22/artifacts/v95frskg_College_and_career_readiness.MP4'
  }
];

const VideosSection = () => {
  return (
    <section id="videos" className="py-20 lg:py-32 bg-white" data-testid="videos-section">
      <div className="container mx-auto px-6 lg:px-20">
        <div className="text-center mb-14 lg:mb-20">
          <div className="inline-flex items-center gap-2 text-purple-700 font-semibold uppercase tracking-wide text-sm mb-4">
            <PlayCircle className="h-5 w-5" />
            Watch
          </div>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-purple-950 mb-6 leading-[1.1] tracking-tight">
            Hear From Clianda
          </h2>
          <p className="text-lg lg:text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed">
            See where Clianda Florence stands on the issues that matter most to our community.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-10 max-w-6xl mx-auto">
          {videos.map((video) => (
            <div
              key={video.id}
              className="group bg-purple-50 rounded-2xl overflow-hidden border border-purple-100 shadow-lg hover:shadow-2xl transition-all duration-300"
              data-testid={`video-card-${video.id}`}
            >
              <div className="relative bg-black aspect-video">
                <video
                  src={video.src}
                  controls
                  preload="metadata"
                  playsInline
                  className="w-full h-full object-contain"
                  data-testid={`video-player-${video.id}`}
                />
              </div>
              <div className="p-6 lg:p-8">
                <h3 className="text-xl lg:text-2xl font-bold text-purple-950 mb-2 leading-tight">
                  {video.title}
                </h3>
                <p className="text-base text-slate-600 leading-relaxed">
                  {video.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export { VideosSection };
